import { Title1Program } from './types'

export const TITLE_1_PROGRAM_OPTIONS: Record<
  NonNullable<Title1Program>,
  { value: NonNullable<Title1Program>; label: string }
> = {
  swp: {
    value: 'swp',
    label: 'Schoolwide Program',
  },
  tas: {
    value: 'tas',
    label: 'Targeted Assistance',
  },
}
